var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 23.9001C6.98009 23.9001 2.1 19.02 2.1 13.0001C2.1 6.98022 6.98009 2.10012 13 2.10012C19.0199 2.10012 23.9 6.98022 23.9 13.0001C23.9 19.02 19.0199 23.9001 13 23.9001ZM0.499998 13.0001C0.499998 19.9037 6.09644 25.5001 13 25.5001C19.9036 25.5001 25.5 19.9037 25.5 13.0001C25.5 6.09656 19.9036 0.500122 13 0.500122C6.09644 0.500122 0.499998 6.09656 0.499998 13.0001ZM11.75 11.7499C11.75 11.0595 12.3096 10.4999 13 10.4999C13.6904 10.4999 14.25 11.0595 14.25 11.7499V17.9999C14.25 18.6902 13.6904 19.2499 13 19.2499C12.3096 19.2499 11.75 18.6902 11.75 17.9999V11.7499ZM13 6.74988C12.3096 6.74988 11.75 7.30952 11.75 7.99988C11.75 8.69023 12.3096 9.24988 13 9.24988C13.6904 9.24988 14.25 8.69023 14.25 7.99988C14.25 7.30952 13.6904 6.74988 13 6.74988Z",
    fill: "#708BE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.50141cf9671fd6feac8461449535e91e.svg";
export { ForwardRef as ReactComponent };